<template>
  <div class="trial-extension">
    <!-- Info -->
    <div class="info-wrapper">
      <h3 v-html="content.title"></h3>
      <p v-html="content.description"></p>
    </div>

    <!-- Ratings -->
    <div v-if="ratings.show" class="ratings-wrapper">
      <img
        src="/assets/images/logos/zendesk.jpg"
        class="zendesk-rating"
        alt="Zendesk logo"
      />
      <div class="star-ratings-wrapper">
        <span class="star-title">{{ ratings.title }}</span>
        <div class="star-ratings-block">
          <span class="rating-value">{{ ratings.rating }}</span>
          <div class="star-ratings">
            <img
              v-for="star in ratings.stars"
              :key="star"
              src="/assets/images/star.png"
              alt="Star rating"
            />
          </div>
        </div>
      </div>
    </div>

    <!-- Button and steps -->
    <div class="steps-wrapper">
      <a
        :href="marketplaceUrl"
        target="_blank"
        class="btn btn-small btn-border green btn-marketplace"
        >{{ content.buttonText }}</a
      >
      <div class="steps-list">
        <div class="steps-body">
          <div class="arrow-up"></div>
          <h3>{{ steps.title }}</h3>
          <div
            v-for="(step, index) in steps.list"
            :key="index"
            class="step-item"
          >
            <b>Step {{ index + 1 }}</b>
            <span v-html="step"></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TrialExtension",
  props: {
    content: {
      type: Object,
      default: () => ({
        title: "Extend your trial",
        description: "",
        buttonText: "Review & extend free trial",
      }),
    },
    ratings: {
      type: Object,
      default: () => ({
        title: "Support teams love Macha AI",
        rating: "5.0",
        show: true,
        stars: 5,
      }),
    },
    marketplaceUrl: String,
    steps: {
      type: Object,
      default: () => ({
        list: [],
        title: "How to extend your trial",
      }),
    },
  },
  data() {
    return {};
  },
  computed: {},
  created() {},
  methods: {},
};
</script>

<style scoped lang="scss">
@import "@/assets/styles/shared/dashboard.scss";

.trial-extension {
  position: relative;
  padding: 1.5rem;
  background: lighten($greenColor, 41.5%);
  border: 1px solid darken($greenColor, 10%);
  border-radius: 1rem;
}

.info-wrapper {
  h3 {
    color: darken($greenColor, 45%);
    font-size: $mediumFontSize;
    margin-bottom: 0;
  }
}

.ratings-wrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 0.5rem;

  .zendesk-rating {
    display: block;
    border-radius: 5px;
    width: 2rem;
    margin-right: 1rem;
    border: 1px solid #1e4b51;
  }

  .star-title {
    display: block;
    font-size: $smallerFontSize;
    color: darken($greenColor, 40%);
    margin-bottom: -2px;
  }

  .star-ratings-block {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .rating-value {
    font-size: $mediumFontSize;
    font-weight: $boldFontWeight;
    color: darken($greenColor, 40%);
    margin-right: 0.5rem;
  }

  .star-ratings {
    display: flex;
    flex-direction: row;
    align-items: center;

    img {
      display: block;
      width: 1.05rem;
      margin: 0 2px;
    }
  }
}

.btn-marketplace {
  display: block;
  margin-top: 1.5rem;
}

.steps-wrapper {
  position: relative;

  &:hover .steps-list {
    display: block;
  }

  .steps-body {
    position: relative;
    padding: 1rem 1.5rem;
    border-radius: 1rem;
    background: $blackColor;
    border: 5px solid lighten($blackColor, 15%);

    .arrow-up {
      width: 0;
      height: 0;
      border-left: 0.85rem solid transparent;
      border-right: 0.85rem solid transparent;
      border-bottom: 0.85rem solid lighten($blackColor, 15%);
      position: absolute;
      left: 0;
      right: 0;
      bottom: calc(100% + 4px);
      margin: auto;
    }
  }
}

.steps-list {
  display: none;
  position: absolute;
  top: 100%;
  padding-top: 1rem;
  left: 0;
  right: 0;

  h3 {
    color: $whiteColor;
    font-size: $smallFontSize;
  }

  .step-item {
    margin-top: 1rem;
    display: flex;
    flex-direction: row;
    align-items: flex-start;

    b {
      display: block;
      font-size: $smallerFontSize;
      color: lighten($greyColor, 40%);
      width: 4rem;
      line-height: 1.3rem;
    }

    span {
      display: block;
      line-height: 1.3rem;
      flex: 1;
      margin-bottom: 0;
      font-size: $smallFontSize;
      color: darken($whiteColor, 10%);
    }
  }
}
</style>
